import './index.css';
import ReactGA from 'react-ga4';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PlansProvider } from './context/PlansContext';
import { ProjectsProvider } from './context/ProjectsContext';
import { PollingProvider } from './context/PollingContext';
import { IntegrationsProvider } from './context/IntegrationsContext';

import AppRoutes from './routes/AppRoutes';
const queryClient = new QueryClient();

const MEASUREMENT_ID = 'G-3GVYEYB7EL';
ReactGA.initialize(MEASUREMENT_ID);

function App() {
  return (
    <div className="w-full transition-all duration-1000 ease-in-out bg-frame-main">
      <QueryClientProvider client={queryClient}>
        <ProjectsProvider>
          <PlansProvider>
            <IntegrationsProvider>
              <PollingProvider>
                <AppRoutes />
              </PollingProvider>
            </IntegrationsProvider>
          </PlansProvider>
        </ProjectsProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
